module.exports = __webpack_public_path__ + "122f31592a901f0accab5b7e2a05f5ff.svg";